"use client";

import type { MouseEvent } from "react";
import { useCallback } from "react";
import {
  ENERGY_COST_PER_MATCH,
  tickEnergyRegen,
  useEnergyMeta,
} from "@/stores/energyMeta";
import { useNoEnergyModal } from "@/stores/noEnergyModal";

/**
 * Returns an onClick handler that opens the full-screen "Out of energy"
 * modal and blocks the wrapped action when the player has < the per-match
 * energy cost. When energy is sufficient, the original click flows through
 * untouched (Link navigation, router.push, etc.).
 */
export function useNoEnergyGate(): (e?: MouseEvent) => boolean {
  const show = useNoEnergyModal((s) => s.show);

  return useCallback(
    (e?: MouseEvent) => {
      tickEnergyRegen();
      const current = useEnergyMeta.getState().energy;
      if (current >= ENERGY_COST_PER_MATCH) return true;

      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      show();
      return false;
    },
    [show],
  );
}
